import { useState } from "react";
import { Box, Button, IconButton, Paper, Typography } from "@mui/material";
import {
  IconBrandChrome,
  IconBrandFirefox,
  IconPlayerPlay,
  IconX,
} from "@tabler/icons-react";
import chromeWebStoreBadge from "../../../../assets/chrome-web-store-badge.png";
import felixAnalytics from "../../../../felixAnalytics";
import { radius } from "../../../../theme";
import ExtensaoVideoDialog from "./extensaoVideoDialog";

// Listagem viva na Chrome Web Store. Firefox ainda não publicado (em breve).
const CHROME_WEBSTORE_URL =
  "https://chromewebstore.google.com/detail/felix-na-bolsa/dmpgbeccbienbocnenmgnjenhdkfkjel";

const DISMISS_KEY = "felix_extension_banner_dismissed";

export default function ExtensaoBanner() {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === "true",
  );
  const [openVideo, setOpenVideo] = useState(false);

  if (dismissed) return null;

  function handleDismiss() {
    localStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
    felixAnalytics.track("extensao_banner_dispensado");
  }

  return (
    <Paper
      variant="outlined"
      sx={(theme) => ({
        position: "relative",
        p: 2,
        pr: 5, // espaço para o botão de dispensar
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
        borderRadius: `${radius.xl}px`,
        // Barra de destaque em accent-ink (tinta), não em accent sólido.
        borderLeft: `3px solid ${theme.palette.accentInk}`,
      })}
    >
      {/* Badge oficial no início — passa autoridade/legitimidade da loja */}
      <Box
        component="a"
        href={CHROME_WEBSTORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          felixAnalytics.track("extensao_banner_click", {
            destino: "chrome_web_store",
            origem: "badge",
          })
        }
        sx={{ display: "inline-flex", lineHeight: 0, flexShrink: 0 }}
      >
        <Box
          component="img"
          src={chromeWebStoreBadge}
          alt="Disponível na Chrome Web Store"
          sx={{ height: 48, width: "auto", display: "block" }}
        />
      </Box>

      <Box flex={1} minWidth={0}>
        <Typography variant="eyebrow" component="p" color="text.secondary">
          Extensão
        </Typography>
        <Typography variant="h4" sx={{ mt: 0.5 }}>
          Baixe o Extrato de Negociação da B3 com 1 clique.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Com a nossa extensão, você o baixa Extrato de Negociação da B3 muito
          mais rápido, pronto para subir aqui.
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            mt: 1,
          }}
        >
          <IconBrandChrome size={14} />
          <IconBrandFirefox size={14} />
          Disponível para o Google Chrome e em breve também no Firefox.
        </Typography>
      </Box>

      {/* Sem `size="small"`: o par de botões tem que ter a mesma altura, e o
          "Instalar no Chrome" ao lado é medium. Ícone em 18px pelo mesmo motivo. */}
      <Button
        variant="outlined"
        startIcon={<IconPlayerPlay size={18} />}
        onClick={() => {
          felixAnalytics.track("extensao_banner_click", {
            destino: "video_demonstracao",
          });
          setOpenVideo(true);
        }}
        sx={{
          flexShrink: 0,
          alignSelf: { xs: "flex-start", sm: "center" },
        }}
      >
        Ver demonstração
      </Button>

      <Button
        variant="contained"
        href={CHROME_WEBSTORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={<IconBrandChrome size={18} />}
        onClick={() =>
          felixAnalytics.track("extensao_banner_click", {
            destino: "chrome_web_store",
          })
        }
        sx={{
          flexShrink: 0,
          alignSelf: { xs: "flex-start", sm: "center" },
          whiteSpace: "nowrap",
        }}
      >
        Instalar no Chrome
      </Button>

      <IconButton
        aria-label="Dispensar"
        size="small"
        onClick={handleDismiss}
        sx={(theme) => ({
          position: "absolute",
          top: 6,
          right: 6,
          color: theme.palette.text.secondary,
          "&:hover": {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.ink["08"],
          },
        })}
      >
        <IconX size={18} />
      </IconButton>

      <ExtensaoVideoDialog
        open={openVideo}
        onClose={() => setOpenVideo(false)}
      />
    </Paper>
  );
}
